import { useState, useEffect } from 'react';

export const useGeolocation = () => {
  const [location, setLocation] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleSuccess = (position) => {
      const { latitude, longitude } = position.coords;
      setLocation({ lat: latitude, lng: longitude });
    };

    const handleError = (error) => {
      setError(error.message);
    };

    const checkPermission = async () => {
      try {
        const status = await navigator.permissions.query({ name: 'geolocation' });
        if (status.state === 'granted' || status.state === 'prompt') {
          navigator.geolocation.getCurrentPosition(handleSuccess, handleError);
        }
      } catch (err) {
        setError('Geolocation permission error');
      }
    };

    checkPermission();
  }, []);

  return { location, error };
};
